import { axiosInstance } from "./apiInstance";
import { setUser } from "actions/user";
import get from "lodash/get";
import { reloadUser } from "utils/functions";
import promiseCache from "../utils/promiseCache";
import * as urls from "./urls";

export const getPickupStats = (clientId) => {
	return (dispatch) => {
		return axiosInstance
			.get(urls.getPickupStats, {
				params: {
					client_id: clientId,
				},
			})
			.catch((err) => {
				let errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
	};
};

export const getClientStats = (clientId) => {
	const cacheKey = `getClientStats_${clientId}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}
		const promise = axiosInstance
			.get(urls.getClientStats, {
				params: {
					client_id: clientId,
				},
			})
			.catch((err) => {
				let errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					let { credit_limit, credit_utilized } = response.data;
					const getCreditPercentage = () => {
						if (credit_limit > 0) {
							return credit_utilized > 0
								? (credit_utilized / credit_limit) * 100
								: 0;
						}
						return credit_utilized;
					};
					let creditPerc = getCreditPercentage();

					let credit_percentage = creditPerc
						? parseFloat(creditPerc.toFixed(0))
						: 0;

					return {
						...response.data,
						credit_percentage,
					};
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};

export const getSlaReports = (clientId, daterange = {}) => {
	const cacheKey = `getSlaReports_${clientId}_${JSON.stringify(daterange)}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}
		const promise = axiosInstance
			.get(urls.getSlaReports, {
				params: {
					client_id: clientId,
					...daterange,
				},
			})
			.catch((err) => {
				let errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};

export const getTargetReports = (params) => {
	const cacheKey = `getTargetReports_${JSON.stringify(params)}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}
		const promise = axiosInstance
			.get(urls.getWeightTarget, {
				params: { ...params },
			})
			.catch((err) => {
				let errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};
export const postGstinApi = (obj) => {
	let body = JSON.stringify(obj);
	return (dispatch) => {
		return axiosInstance
			.post(urls.gstinApi, body)
			.catch((err) => {
				let errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					let err = new Error(response.data.msg);
					throw err;
				}
			});
	};
};
